
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.61 12.188a7.907 7.907 0 001.239-4.256C15.849 3.552 12.302 0 7.927 0A7.929 7.929 0 000 7.932c0 4.38 3.547 7.933 7.922 7.933a7.905 7.905 0 004.307-1.271l.36-.25L18.245 20 20 18.214l-5.651-5.657.26-.37zm-2.982-7.951a5.186 5.186 0 011.528 3.69 5.186 5.186 0 01-1.528 3.69 5.186 5.186 0 01-3.69 1.529 5.186 5.186 0 01-3.691-1.528 5.186 5.186 0 01-1.528-3.69c0-1.395.542-2.706 1.528-3.691a5.186 5.186 0 013.69-1.529c1.394 0 2.705.543 3.691 1.529z","fill":"#8E8E92","fill-rule":"nonzero"}})])
          )
        }
      }
    